import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-119">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-120">
        <div className="absolute inset-0 bg-kiron-black opacity-90 z-10" data-id="element-121"></div>
        <img src="https://cdn.magicpatterns.com/uploads/cgGrM6vDonxc8zFpe3vS4R/SaveClip.App_618144395_17872768035508306_3873199516963268169_n.jpg" alt="Kiron Gym Background" className="w-full h-full object-cover object-center opacity-40 grayscale" data-id="element-122" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full flex flex-col items-center text-center" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/gmjbqi7Rif9BiiKcd8ezw3/logo_fondo_negro.jpg" alt="Kiron Performance Logo" className="h-24 md:h-32 lg:h-40 object-contain mx-auto mix-blend-screen" data-id="element-125" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-oswald font-bold text-white leading-tight mb-6 tracking-tight" data-id="element-126">
          TRANSFORMACIÓN REAL.
          <br data-id="element-127" />
          <span className="text-kiron-teal" data-id="element-128">RENDIMIENTO VISIBLE.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto font-light tracking-wide" data-id="element-129">
          Evaluación + planificación + corrección constante.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-6 justify-center w-full sm:w-auto" data-id="element-130">
          <a href="https://wa.me/541133016499?text=Hola%20quiero%20agendar%20una%20clase%20de%20prueba" target="_blank" rel="noopener noreferrer" className="bg-kiron-teal text-kiron-black font-oswald font-bold text-xl px-10 py-4 uppercase tracking-wider hover:scale-105 hover:brightness-110 transition-all duration-300 text-center" data-id="element-131">
            Empezá tu transformación hoy
          </a>
          <a href="https://maps.app.goo.gl/63qKPXbZ4syc2dQs9" target="_blank" rel="noopener noreferrer" className="bg-transparent border-2 border-white text-white font-oswald font-bold text-xl px-10 py-4 uppercase tracking-wider hover:bg-white hover:text-kiron-black transition-all duration-300 text-center" data-id="element-132">
            Conocé nuestra sede
          </a>
        </motion.div>
      </div>
    </section>;
}